export const ROOM_INDEX_PLACEHOLDER = "{roomIndex}";
export const ROOM_CHILD_INDEX_PLACEHOLDER = "{childIndex}";
export const CHILD_AGE_SELECT_ID_PATTERN = `child-age-select-${ROOM_INDEX_PLACEHOLDER}-${ROOM_CHILD_INDEX_PLACEHOLDER}`;
